// extracted by mini-css-extract-plugin
export default {"theMenu":"Menu_theMenu__7i0sL","deleteMenu":"Menu_deleteMenu__P4y+J","typeMenu":"Menu_typeMenu__4si8j","menuName":"Menu_menuName__u4gpC"};